<div *ngIf="!loading" @coreShowHideAnimation>
    <ng-content />
</div>

<!-- Spinner. -->
<ion-spinner *ngIf="loading" @coreShowHideAnimation [attr.aria-label]="loadingLabel | translate" />
